import { render } from "./LandingPage.vue?vue&type=template&id=7027479c&scoped=true&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=7027479c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7027479c"]])

export default __exports__